"use strict";

var _jsxRuntime = require("react/jsx-runtime");

module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M10.412 19.186a.956.956 0 0 0 .838-.464L19.094 6.37c.064-.1.117-.208.158-.32a.9.9 0 0 0 .05-.295.74.74 0 0 0-.208-.548.741.741 0 0 0-.548-.208.776.776 0 0 0-.407.1c-.126.085-.23.197-.307.328l-7.453 11.875-3.87-5.063a.87.87 0 0 0-.713-.407.783.783 0 0 0-.573.22.752.752 0 0 0-.224.56c.001.103.02.204.058.3.044.11.106.21.183.3l4.309 5.493a1.08 1.08 0 0 0 .863.481Z"
  })]
});